import React from "react";
import logo from "./logo.svg";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Snackbar from "./components/Snackbar/Snackbar";

const AppContent = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Snackbar />
        <AppContent />
      </Provider>
    </div>
  );
}

export default App;
